import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_BASE_URL,
    timeout: 0,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json;charset=UTF-8',
    }
});

export default {
    namespaced: true,

    state: {
        status: null,
        userAccount: null,
        menuItems: [
            {
                icon: "mdi-school",
                text: "School Home",
                to: "/school",
                accountType: "School"
            },
            {
                icon: "mdi-account-child-circle",
                text: "Parent Home",
                to: "/parent",
                accountType: "Parent"
            }
        ],
        profileMenuItems: [
            { title: "Profile", to: "/user", type: "page" },
            { title: "Settings", to: "/user/settings", type: "page" },
            { type: "divider" },
            { title: "Sign out", type: "signout-action" }
        ],
    },

    getters: {
        account: state => state.userAccount,
        role: state => (state.userAccount !== null ? state.userAccount.role : ''),
        accountType: state => (state.userAccount !== null ? state.userAccount.accountType : 'Parent'),
        token(state, getters, rootState, rootGetters) {
            return rootState.authenticationService.idToken;
        },
        appBarMenuItems(state, getters) {
            const items = [];
            const accountType = getters.accountType;

            state.menuItems.forEach((menuItem) => {
                if (menuItem.accountType === accountType) {
                    items.push(menuItem);
                }
            });

            return items;
        },
        profileMenuItems: state => state.profileMenuItems,
    },

    mutations: {
        setStatus(state, status) {
            state.status = status;
        },
        setUserAccount(state, account) {
            state.userAccount = account;
        },

    },

    actions: {
        getUserAccount({ dispatch, commit, getters, rootGetters }) {

            return new Promise((resolve, reject) => {

                dispatch('authenticationService/getIdToken', null, { root: true })
                    .then((token) => {
                        instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                        instance
                            .get('user/account')
                            .then((response) => {
                                // console.log(response.data);
                                commit('setUserAccount', response.data);
                                commit('setStatus', 'success');
                                resolve();
                            })
                            .catch((error) => {
                                commit('setStatus', 'failure');
                                reject();
                            });
                    }).catch((err) => {
                        commit('setStatus', 'failure');
                        reject(err);
                    });

            });
        },
    },
}